<div class="h-full flex flex-col" [class]="systemTabsPageClasses()">
  <lib-filtered-table
    [tableId]="'background-tasks'"
    [tableTitle]="'background_task_list_title' | transloco"
    [titleClass]="
      floating() ? '' : 'w-full mb-2xl pb-lg border-b border-neutral-200'
    "
    [dataSource]="rows()"
    [meta]="meta()"
    [totalItems]="meta()?.total ?? 0"
    [columns]="columns()"
    [isLoadingData]="isLoading()"
    [tableFilterTabs]="tableFilterTabs()"
    [showSearch]="false"
    [isTableExportable]="false"
    [(payload)]="payload"
    [tableColumnTemplates]="[
      { identifier: 'number', template: number },
      { identifier: 'code', template: code },
      { identifier: 'type', template: type },
      { identifier: 'input', template: input },
      { identifier: 'state', template: state },
      { identifier: 'created', template: created },
      { identifier: 'skipped', template: skipped },
      { identifier: 'created_at', template: uploadedAt },
    ]"
    [applyOnStreamChanges]="loadTasks$"
    (streamSucceeds)="applyTasks($event)"
    (handleApiCall)="loadTasks()" />
</div>

<ng-template #number let-i="i">
  @let metaData = meta();
  @if (metaData) {
    <span class="font-semibold">
      {{ (metaData.current_page - 1) * metaData.per_page + (i + 1) }}
    </span>
  }
</ng-template>
<ng-template #code let-row>
  <span class="text-xs font-medium text-neutral-900">{{ row.code }}</span>
</ng-template>
<ng-template #type let-row>
  <span class="text-xs font-medium text-neutral-900">{{ row.type.label }}</span>
</ng-template>
<ng-template #input let-row>
  <span class="text-xs font-medium text-neutral-900">{{
    row.input?.file_name
  }}</span>
</ng-template>
<ng-template #state let-row>
  <lib-badge [label]="row.state.label" [badgeClass]="row.badgeClass" />
</ng-template>
<ng-template #created let-row>
  <span class="text-xs font-medium text-neutral-900">{{ row.created }}</span>
</ng-template>
<ng-template #skipped let-row>
  <span class="text-xs font-medium text-neutral-900">{{ row.skipped }}</span>
</ng-template>
<ng-template #uploadedAt let-row>
  <span class="text-xs font-medium text-neutral-900">{{
    row.created_at | date: 'dd-MMM-yyyy hh:mm a'
  }}</span>
</ng-template>
